<template>
	<div>
		<button
			type="button"
			v-on:click.stop="open = !open"
			:class="buttonClass"
			aria-controls="sub-menu-1"
			aria-expanded="false"
		>
			<slot name="button"></slot>
			<ui-icon
				class="flex-shrink-0 h-6 w-6 text-white"
				:name="open ? 'chevron-up' : 'chevron-down'"
				stroke-width="1.5"
			/>
		</button>

		<div class="space-y-1" v-if="open">
			<slot name="items">
				<a
					href="#"
					class="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-green-300 rounded-md hover:text-green-100 hover:bg-green-500"
					>Report 1</a
				>
				<a
					href="#"
					class="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-green-300 rounded-md hover:text-green-100 hover:bg-green-500"
					>2n Analysis</a
				>
				<a
					href="#"
					class="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-green-300 rounded-md hover:text-green-100 hover:bg-green-500"
					>Example Link</a
				>
				<a
					href="#"
					class="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-green-300 rounded-md hover:text-green-100 hover:bg-green-500"
					>More links</a
				>
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		buttonClass: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			open: false,
		};
	},
};
</script>
